import { languageHelper } from "../../../config/helperFunctions";
import React from 'react'
import Select from "react-select";
import { useNavigate } from "react-router-dom";

function AddAttendanceForm() {
  const navigate = useNavigate();
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-[#7B20C7] text-2xl"> {languageHelper("Add/Update Attendance")}</h1>
          </div>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={e => e.preventDefault()}>

            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full ">
              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2 font-bold">
                {languageHelper("Reference No")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="000001"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required />
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Date")}
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder={languageHelper("Date")} className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full " required />
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                {languageHelper("Employee")}  
                </span>
                <div className="mb-2 pt-0">
                  <Select type="text" placeholder={languageHelper("Select")} className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full " required />
                </div>
              </label>
            </div>

            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full ">
              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2  relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                {languageHelper("In Time")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("In Time")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required />
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2 font-bold">
                {languageHelper("Out Time")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Out Time")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required />
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2  font-bold">
                 {languageHelper("Note")}
                </span>
                <div className="mb-2 pt-0">
                  <textarea rows="3" type="text" placeholder={languageHelper("Note")} className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full " required />
                </div>
              </label>
  </div>

        

            <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="submit"
              >
                {languageHelper("Submit")}
              </button>
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
            </div>
          </form>
        </div>


      </div>
    </main>
  );
}

export default AddAttendanceForm